// @flow

export default class LayoutElement {
  StudyInstanceUID: string;

  SeriesInstanceUID: string;

  initOptions: Object = {};

  renderType: string = undefined;

  availableRenderers: Array<string> = [];

  isPlayingCine: Boolean = false;

  isSynchedFrames: Boolean = false;

  isFixedWLPreset: Boolean = false;

  isMagnifyingGlass: Boolean = false;
}
